import { baseUrl } from '../../config/clientsConfig'
import axios from "axios";

const marketingHubService = {
  fetchGroups: () => axios.get(`${baseUrl}/groups`),
  updateGroup: (groupData) => axios.put(`${baseUrl}/group`, groupData),
  deleteTemplate: (templateId) =>
    axios.delete(`${baseUrl}/textAndImageTemplate?templateId=${templateId}`),
  deleteDocumentTemplate: (templateId) =>
    axios.delete(`${baseUrl}/documentTemplate/?templateId=${templateId}`),
  createGroup: (groupData) => axios.post(`${baseUrl}/group`, groupData),
  createTextAndImageTemplate: (templateData) =>
    axios.post(`${baseUrl}/textAndImageTemplate`, templateData),

  createDocumentTemplate: (templateData) => axios.post(`${baseUrl}/documentTemplate`, templateData),
  createImageTemplate: (formData) =>
    axios.post(`${baseUrl}/templateImage`, formData,  {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
),
createDocumentTemplatePdf: (formData) =>
  axios.post(`${baseUrl}/templateDocument`, formData,  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
),

sendEmail: (mailContent) =>
  axios.post(`${baseUrl}/bulkMailSend`, mailContent,  {

  }
),
  updateTextAndImageTemplate: (templateData) =>
    axios.put(`${baseUrl}/textAndImageTemplate`, templateData),

  getTextAndImage: (groupId) =>
    axios.get(`${baseUrl}/textAndImageTemplates?groupId=${groupId}`),

  getDocuments: (groupId) =>
    axios.get(`${baseUrl}/documentTemplates?groupId=${groupId}`),
  getLeadBasedOnStatusWithId: (leadStatus)=>axios.get(`${baseUrl}/leadsByStatusWithId?leadStatus=${leadStatus}`)
};

export default marketingHubService;
